import { render, staticRenderFns } from "./CataloguePanel.vue?vue&type=template&id=7825866b&scoped=true&"
import script from "./CataloguePanel.vue?vue&type=script&lang=js&"
export * from "./CataloguePanel.vue?vue&type=script&lang=js&"
import style0 from "./CataloguePanel.vue?vue&type=style&index=0&id=7825866b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825866b",
  null
  
)

export default component.exports